import { Component } from '@angular/core';
import { HeaderComponent } from '../../layout/header/header.component';
import { NavbarComponent } from '../../layout/navbar/navbar.component';
import { SidebarComponent } from '../../layout/sidebar/sidebar.component';
import { RoutelinksService } from '../../services/core/routelinks.service';
import {
  LangChangeEvent,
  TranslatePipe,
  TranslateService,
} from '@ngx-translate/core';
import {
  CoinDto,
  CoinRequest,
  CoinResponse,
} from '../../models/coins/CoinDto.model';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
  ReactiveFormsModule,
} from '@angular/forms';
import { messageVisibility } from '../../models/messageVisibility.model';
import { Subscription } from 'rxjs';
import { CurrencyService } from '../../services/currencyService.service';
import { SharedService } from '../../services/shared.service';
import { CommonModule } from '@angular/common';
import { AlertComponentComponent } from '../../components/alert/alert-component.component';
import { MessageInputComponent } from '../../layout/message-input/message-input.component';

@Component({
  selector: 'app-coins',
  standalone: true,
  imports: [
    HeaderComponent,
    NavbarComponent,
    SidebarComponent,
    TranslatePipe,
    CommonModule,
    AlertComponentComponent,
    ReactiveFormsModule,
    MessageInputComponent,
  ],
  templateUrl: './coins.component.html',
  styleUrl: './coins.component.css',
})
export class CoinsComponent {
  [x: string]: any;
  links: any[] = [];
  serviceForm!: FormGroup;
  coinReponse: CoinResponse = new CoinResponse();
  coinReponseTraductions: CoinDto[] = [];
  coinRequest: CoinRequest = new CoinRequest();
  coinSelected: CoinDto = new CoinDto();
  selectedRowId: string | null = null;
  coinForm!: FormGroup;
  isCreate: boolean = false;
  errorMessage: string = '';
  messageVisibility: messageVisibility = new messageVisibility();
  private langChangeSubscription!: Subscription;

  constructor(
    private routelinks: RoutelinksService,
    private translateService: TranslateService,
    private coinService: CurrencyService,
    private formBuilder: FormBuilder,
    public sharedService: SharedService
  ) {
    this.links = this.routelinks.linksCoins;
  }

  ngOnInit(): void {
    this.initFormReactiveCoin();
    this.getAllCoins();
    this.langChangeSubscription = this.translateService.onLangChange.subscribe(
      (event: LangChangeEvent) => {
        this.getAllCoins();
      }
    );
  }

  ngOnDestroy(): void {
    if (this.langChangeSubscription) {
      this.langChangeSubscription.unsubscribe(); // Desuscribirse del evento de cambio de idioma
    }
  }

  private initFormReactiveCoin(): void {
    this.coinForm = this.formBuilder.group({
      currencyCode: ['', [Validators.required]],
      decimalAdjustment: [0, [Validators.required]],
      descriptionCas: [''],
      descriptionCat: [''],
      descriptionEng: [''],
    });
  }

  getAllCoins() {
    this.coinService.getAllCurrency().subscribe({
      next: (response) => {
        if (response != null) {
          console.log(response);
          this.coinReponseTraductions = response.listCurrency;
          this.coinReponse.coinDto = response.listCurrency.map((rt: any) => {
            return {
              ...rt,
              currencyTraductionDto: rt.currencyTraductionDto.filter(
                (t: any) => {
                  return t.languageDto.code.includes(
                    this.translateService.currentLang || 'es'
                  );
                }
              ),
            };
          });
          response.pageDto !== undefined
            ? (this.coinReponse.pageDto = response.pageDto)
            : null;
        }
      },
      error: (error) => {
        console.log('Se ha producido un error', error);
      },
    });
  }

  checkRow(coin?: CoinDto) {
    if (!coin || !coin.currencyCode) {
      this.selectedRowId = null;
      return;
    }

    const code = coin.currencyCode;

    if (this.selectedRowId === code) {
      this.selectedRowId = null;
    } else {
      this.selectedRowId = code;
    }
  }

  private resetValues(): void {
    this.getAllCoins();
    this.coinForm.reset();
    this.selectedRowId = null;
  }

  createOrUpdateCoin(): void {
    //modo creacion
    if (this.coinForm.valid) {
    } else {
      this.coinForm.markAllAsTouched();
    }
  }
}
